const nav = document.querySelector("[data-nav-drawer]");
const cart = document.querySelector("[data-cart-drawer]");
const wishlistDrawer = document.querySelector("[data-wishlist-drawer]");
const popup = document.querySelector("[data-email-popup]");
const toast = document.querySelector("[data-toast]");
const countEls = document.querySelectorAll("[data-cart-count]");
const wishlistCountEls = document.querySelectorAll("[data-wishlist-count]");
const cartItemsEls = document.querySelectorAll("[data-cart-items]");
const cartSubtotalEls = document.querySelectorAll("[data-cart-subtotal]");
const cartCheckoutEls = document.querySelectorAll("[data-cart-checkout]");
const wishlistItemsEl = document.querySelector("[data-wishlist-items]");
const WISHLIST_KEY = window.ISL?.wishlistKey || "isl-wishlist";

function openDrawer(el) {
  if (!el) return;
  el.hidden = false;
  document.body.classList.add("drawer-open");
}

function closeDrawer(el) {
  if (!el) return;
  el.hidden = true;
  const anyOpen = [nav, cart, wishlistDrawer, popup].some((drawer) => drawer && !drawer.hidden);
  if (!anyOpen) {
    document.body.classList.remove("drawer-open");
  }
}

function showToast(message) {
  if (!toast) return;
  toast.textContent = message;
  toast.hidden = false;
  window.clearTimeout(showToast._t);
  showToast._t = window.setTimeout(() => {
    toast.hidden = true;
    toast.textContent = "Added to cart";
  }, 1800);
}

function formatMoney(cents) {
  if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
    return Shopify.formatMoney(cents, window.ISL?.moneyFormat || "${{amount}}");
  }

  const amount = (Number(cents || 0) / 100).toFixed(2);
  const format = window.ISL?.moneyFormat || "Rs.{{amount}}";
  return format.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(Number(cents || 0) / 100)));
}

function escapeHtml(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

async function fetchCart() {
  const response = await fetch("/cart.js", {
    headers: { Accept: "application/json" },
  });

  if (!response.ok) {
    throw new Error("Could not load cart");
  }

  return response.json();
}

function cartLineHtml(item) {
  const variant =
    item.variant_title && item.variant_title !== "Default Title"
      ? `<p class="drawer-line__variant">${escapeHtml(item.variant_title)}</p>`
      : "";

  return `
    <div class="drawer-line cart-line" data-cart-line="${item.key}">
      ${
        item.image
          ? `<a class="drawer-line__media" href="${item.url}"><img src="${item.image}" alt="${escapeHtml(item.product_title)}" width="80" height="80" loading="lazy"></a>`
          : ""
      }
      <div class="drawer-line__body">
        <div class="drawer-line__top">
          <p class="drawer-line__title"><a href="${item.url}">${escapeHtml(item.product_title)}</a></p>
          <button class="drawer-line__remove" type="button" data-cart-remove="${item.key}" aria-label="Remove">×</button>
        </div>
        ${variant}
        <div class="drawer-line__foot">
          <div class="cart-qty">
            <button type="button" data-cart-qty-minus="${item.key}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-qty-plus="${item.key}" aria-label="Increase quantity">+</button>
          </div>
          <strong class="drawer-line__price">${formatMoney(item.final_line_price)}</strong>
        </div>
      </div>
    </div>
  `;
}

function cartEmptyHtml() {
  return `
    <div class="drawer-empty">
      <p>Your cart is empty.</p>
      <a class="btn btn--ghost btn--full" href="/collections/all">Continue shopping</a>
    </div>
  `;
}

function renderCartLines(cartData) {
  if (!cartItemsEls.length) return;

  const html = !cartData.item_count
    ? cartEmptyHtml()
    : cartData.items.map((item) => cartLineHtml(item)).join("");

  cartItemsEls.forEach((el) => {
    el.innerHTML = html;
  });
}

function updateCartDrawerMeta(cartData) {
  const cartDrawerCountEl = document.querySelector("[data-cart-drawer-count]");
  if (cartDrawerCountEl) {
    cartDrawerCountEl.textContent = cartData.item_count
      ? `${cartData.item_count} item${cartData.item_count === 1 ? "" : "s"}`
      : "Your cart is empty.";
  }

  document.querySelectorAll("[data-cart-foot]").forEach((foot) => {
    foot.hidden = cartData.item_count === 0;
  });
}

function updateCartUi(cartData) {
  countEls.forEach((el) => {
    el.textContent = String(cartData.item_count);
  });
  cartSubtotalEls.forEach((el) => {
    el.textContent = formatMoney(cartData.total_price);
  });
  renderCartLines(cartData);
  updateCartDrawerMeta(cartData);

  cartCheckoutEls.forEach((checkoutEl) => {
    if (cartData.item_count > 0) {
      checkoutEl.href = "/checkout";
      checkoutEl.classList.remove("is-disabled");
      checkoutEl.removeAttribute("aria-disabled");
      checkoutEl.removeAttribute("tabindex");
    } else {
      checkoutEl.href = "#";
      checkoutEl.classList.add("is-disabled");
      checkoutEl.setAttribute("aria-disabled", "true");
      checkoutEl.setAttribute("tabindex", "-1");
    }
  });
}

async function refreshCart() {
  const cartData = await fetchCart();
  updateCartUi(cartData);
  return cartData;
}

async function addToCart(form) {
  const formData = new FormData(form);
  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { Accept: "application/json" },
    body: formData,
  });

  const payload = await response.json();

  if (!response.ok) {
    throw new Error(payload.description || payload.message || "Could not add to cart");
  }

  await refreshCart();
  openDrawer(cart);
  showToast("Added to cart");
}

async function changeCartLine(lineKey, quantity) {
  const response = await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id: lineKey, quantity }),
  });

  const payload = await response.json();

  if (!response.ok) {
    throw new Error(payload.description || payload.message || "Could not update cart");
  }

  updateCartUi(payload);

  if (document.body.dataset.page === "cart" && !payload.item_count) {
    window.location.reload();
  }
}

async function adjustCartQty(lineKey, delta) {
  const cartData = await fetchCart();
  const item = cartData.items.find((entry) => entry.key === lineKey);
  if (!item) return;

  const nextQty = item.quantity + delta;
  await changeCartLine(lineKey, nextQty < 1 ? 0 : nextQty);
}

function readWishlist() {
  try {
    const stored = window.localStorage.getItem(WISHLIST_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

function writeWishlist(items) {
  window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
}

function getWishlistItemFromButton(button) {
  return {
    id: String(button.dataset.productId),
    variantId: String(button.dataset.variantId),
    title: button.dataset.productTitle,
    url: button.dataset.productUrl,
    image: button.dataset.productImage,
    price: button.dataset.productPrice,
    comparePrice: button.dataset.productComparePrice || "",
  };
}

function isWishlisted(productId) {
  return readWishlist().some((item) => item.id === String(productId));
}

function updateWishlistButtons() {
  document.querySelectorAll("[data-wishlist-toggle]").forEach((button) => {
    const active = isWishlisted(button.dataset.productId);
    button.classList.toggle("is-active", active);
    button.setAttribute("aria-pressed", active ? "true" : "false");
  });
}

function updateWishlistCount() {
  const count = readWishlist().length;
  wishlistCountEls.forEach((el) => {
    el.textContent = String(count);
  });
}

function wishlistEmptyHtml() {
  return `
    <div class="drawer-empty" data-wishlist-empty>
      <p>Save items you like — they will appear here.</p>
      <a class="btn btn--ghost btn--full" href="/collections/all">Continue shopping</a>
    </div>
  `;
}

function updateWishlistDrawerMeta(count) {
  const wishlistDrawerCountEl = document.querySelector("[data-wishlist-drawer-count]");
  if (wishlistDrawerCountEl) {
    wishlistDrawerCountEl.textContent = count
      ? `${count} saved item${count === 1 ? "" : "s"}`
      : "Save items you like — they will appear here.";
  }

  const wishlistFootEl = document.querySelector("[data-wishlist-foot]");
  if (wishlistFootEl) wishlistFootEl.hidden = count === 0;
}

function renderWishlist() {
  if (!wishlistItemsEl) return;

  const items = readWishlist();
  updateWishlistCount();
  updateWishlistDrawerMeta(items.length);

  if (!items.length) {
    wishlistItemsEl.innerHTML = wishlistEmptyHtml();
    return;
  }

  wishlistItemsEl.innerHTML = items
    .map((item) => {
      const priceHtml = item.price
        ? item.comparePrice
          ? `<p class="drawer-line__price drawer-line__price--solo"><strong>${escapeHtml(item.price)}</strong> <s>${escapeHtml(item.comparePrice)}</s></p>`
          : `<p class="drawer-line__price drawer-line__price--solo"><strong>${escapeHtml(item.price)}</strong></p>`
        : "";

      const mediaHtml = item.image
        ? `<a class="drawer-line__media" href="${item.url}"><img src="${item.image}" alt="${escapeHtml(item.title)}" width="88" height="88" loading="lazy"></a>`
        : `<div class="drawer-line__media drawer-line__media--placeholder" aria-hidden="true"></div>`;

      return `
      <div class="drawer-line wishlist-line" data-wishlist-line="${item.id}">
        ${mediaHtml}
        <div class="drawer-line__body">
          <div class="drawer-line__top">
            <p class="drawer-line__title"><a href="${item.url}">${escapeHtml(item.title)}</a></p>
            <button class="drawer-line__remove" type="button" data-wishlist-remove="${item.id}" aria-label="Remove ${escapeHtml(item.title)}">×</button>
          </div>
          ${priceHtml}
          <div class="drawer-line__actions">
            <button class="btn btn--full btn--checkout" type="button" data-wishlist-add="${item.variantId}" data-product-id="${item.id}">Add to cart</button>
          </div>
        </div>
      </div>
    `;
    })
    .join("");
}

function toggleWishlist(button) {
  const item = getWishlistItemFromButton(button);
  let items = readWishlist();
  const exists = items.some((entry) => entry.id === item.id);

  if (exists) {
    items = items.filter((entry) => entry.id !== item.id);
    showToast("Removed from wishlist");
  } else {
    items.push(item);
    showToast("Saved to wishlist");
  }

  writeWishlist(items);
  updateWishlistButtons();
  updateWishlistCount();
  renderWishlist();
}

async function addWishlistItemToCart(variantId) {
  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  });

  const payload = await response.json();

  if (!response.ok) {
    throw new Error(payload.description || payload.message || "Could not add to cart");
  }

  await refreshCart();
  closeDrawer(wishlistDrawer);
  openDrawer(cart);
  showToast("Added to cart");
}

function initProductVariantForm() {
  const form = document.querySelector("[data-product-page-form]");
  const jsonEl = document.querySelector("[data-product-json]");
  if (!form || !jsonEl) return;

  let product;
  try {
    product = JSON.parse(jsonEl.textContent);
  } catch {
    return;
  }

  const variantInput = form.querySelector("[data-product-variant-id]");
  const optionInputs = [...form.querySelectorAll("[data-product-option]")];
  const priceEl = document.querySelector("[data-product-price]");
  const compareEl = document.querySelector("[data-product-compare-price]");
  const submitBtn = form.querySelector("[data-product-submit]");
  const skuEl = document.querySelector("[data-product-sku]");
  const mainImage = document.querySelector("[data-product-main-image]");
  const badge = document.querySelector(".product-page__badge");

  function syncVariant() {
    const selectedOptions = optionInputs.map((input) => input.value);
    const variant = product.variants.find((entry) =>
      entry.options.every((option, index) => option === selectedOptions[index])
    );

    if (!variant || !variantInput) return;

    variantInput.value = variant.id;

    const wishlistButton = form.querySelector("[data-wishlist-toggle]");
    if (wishlistButton) {
      wishlistButton.dataset.variantId = String(variant.id);
      wishlistButton.dataset.productPrice = formatMoney(variant.price);
      if (variant.compare_at_price > variant.price) {
        wishlistButton.dataset.productComparePrice = formatMoney(variant.compare_at_price);
      } else {
        delete wishlistButton.dataset.productComparePrice;
      }
    }

    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
      priceEl.classList.toggle("product-page__price--sale", variant.compare_at_price > variant.price);
    }

    if (compareEl) {
      if (variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.textContent = "";
        compareEl.hidden = true;
      }
    }

    if (badge) {
      badge.hidden = !(variant.compare_at_price > variant.price);
    }

    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available ? "Add to cart" : "Sold out";
    }

    if (skuEl) {
      skuEl.textContent = variant.sku || String(product.id);
    }

    if (mainImage && variant.featured_image) {
      mainImage.src = variant.featured_image.src;
      mainImage.alt = variant.featured_image.alt || product.title;
    }
  }

  optionInputs.forEach((input) => input.addEventListener("change", syncVariant));
  syncVariant();
}

function initProductGallery() {
  const mainImage = document.querySelector("[data-product-main-image]");
  const thumbs = [...document.querySelectorAll("[data-product-thumb]")];
  if (!mainImage || !thumbs.length) return;

  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      mainImage.src = thumb.dataset.imageSrc;
      mainImage.alt = thumb.dataset.imageAlt || mainImage.alt;

      thumbs.forEach((entry) => {
        const active = entry === thumb;
        entry.classList.toggle("is-active", active);
        entry.setAttribute("aria-pressed", active ? "true" : "false");
      });
    });
  });
}

function initProductQty() {
  const form = document.querySelector("[data-product-page-form]");
  if (!form) return;

  const input = form.querySelector("[data-product-qty]");
  if (!input) return;

  form.querySelector("[data-qty-minus]")?.addEventListener("click", () => {
    input.value = String(Math.max(1, Number(input.value || 1) - 1));
  });

  form.querySelector("[data-qty-plus]")?.addEventListener("click", () => {
    input.value = String(Math.max(1, Number(input.value || 1) + 1));
  });
}

function bindClickAll(selector, handler) {
  document.querySelectorAll(selector).forEach((el) => {
    el.addEventListener("click", handler);
  });
}

document.querySelector("[data-open-menu]")?.addEventListener("click", () => openDrawer(nav));
document.querySelector("[data-close-menu]")?.addEventListener("click", () => closeDrawer(nav));
nav?.addEventListener("click", (event) => {
  if (event.target === nav) closeDrawer(nav);
});
document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  if (nav && !nav.hidden) closeDrawer(nav);
});
bindClickAll("[data-open-cart]", async () => {
  await refreshCart();
  openDrawer(cart);
});
document.querySelector("[data-close-cart]")?.addEventListener("click", () => closeDrawer(cart));
bindClickAll("[data-open-wishlist]", () => {
  renderWishlist();
  openDrawer(wishlistDrawer);
});
document.querySelector("[data-close-wishlist]")?.addEventListener("click", () => closeDrawer(wishlistDrawer));

nav?.addEventListener("click", (e) => {
  if (e.target === nav) closeDrawer(nav);
});

cart?.addEventListener("click", (e) => {
  if (e.target === cart) closeDrawer(cart);
});

wishlistDrawer?.addEventListener("click", (e) => {
  if (e.target === wishlistDrawer) closeDrawer(wishlistDrawer);
});

document.addEventListener("click", async (e) => {
  const qtyMinus = e.target.closest("[data-cart-qty-minus]");
  if (qtyMinus) {
    e.preventDefault();
    try {
      await adjustCartQty(qtyMinus.dataset.cartQtyMinus, -1);
    } catch (error) {
      showToast(error.message);
    }
    return;
  }

  const qtyPlus = e.target.closest("[data-cart-qty-plus]");
  if (qtyPlus) {
    e.preventDefault();
    try {
      await adjustCartQty(qtyPlus.dataset.cartQtyPlus, 1);
    } catch (error) {
      showToast(error.message);
    }
    return;
  }

  const removeBtn = e.target.closest("[data-cart-remove]");
  if (removeBtn) {
    e.preventDefault();
    try {
      await changeCartLine(removeBtn.dataset.cartRemove, 0);
    } catch (error) {
      showToast(error.message);
    }
    return;
  }

  const wishlistToggle = e.target.closest("[data-wishlist-toggle]");
  if (wishlistToggle) {
    e.preventDefault();
    toggleWishlist(wishlistToggle);
    return;
  }

  const wishlistRemove = e.target.closest("[data-wishlist-remove]");
  if (wishlistRemove) {
    e.preventDefault();
    const items = readWishlist().filter((item) => item.id !== wishlistRemove.dataset.wishlistRemove);
    writeWishlist(items);
    updateWishlistButtons();
    renderWishlist();
    showToast("Removed from wishlist");
    return;
  }

  const wishlistAdd = e.target.closest("[data-wishlist-add]");
  if (wishlistAdd) {
    e.preventDefault();
    try {
      await addWishlistItemToCart(wishlistAdd.dataset.wishlistAdd);
    } catch (error) {
      showToast(error.message);
    }
  }
});

document.addEventListener("submit", async (e) => {
  const form = e.target.closest("[data-product-form]");
  if (!form) return;

  e.preventDefault();

  const submitBtn = form.querySelector('[type="submit"]');
  if (submitBtn) submitBtn.disabled = true;

  try {
    await addToCart(form);
  } catch (error) {
    showToast(error.message);
  } finally {
    if (submitBtn) submitBtn.disabled = false;
  }
});

cartCheckoutEls.forEach((checkoutEl) => {
  checkoutEl.addEventListener("click", (e) => {
    if (checkoutEl.classList.contains("is-disabled")) {
      e.preventDefault();
    }
  });
});

updateWishlistButtons();
updateWishlistCount();
renderWishlist();
initProductVariantForm();
initProductGallery();
initProductQty();
initCollectionFilters();

function formatPriceLabel(rupees, symbol) {
  const amount = Math.round(Number(rupees || 0));
  const formatted = amount.toLocaleString("en-PK");
  return `${symbol || "Rs."}${formatted}`;
}

function syncPriceSlider(slider, source) {
  const minRange = slider.querySelector("[data-price-min-range]");
  const maxRange = slider.querySelector("[data-price-max-range]");
  const fill = slider.querySelector("[data-price-range]");
  const minLabel = slider.querySelector("[data-price-min-label]");
  const maxLabel = slider.querySelector("[data-price-max-label]");
  if (!minRange || !maxRange) return;

  const ceiling = Number(slider.dataset.max || maxRange.max || 0);
  let minVal = Number(minRange.value);
  let maxVal = Number(maxRange.value);

  if (minVal > maxVal) {
    if (source === minRange) {
      minRange.value = maxVal;
      minVal = maxVal;
    } else {
      maxRange.value = minVal;
      maxVal = minVal;
    }
  }

  const span = Math.max(ceiling, 1);
  const start = (minVal / span) * 100;
  const end = (maxVal / span) * 100;

  if (fill) {
    fill.style.left = `${start}%`;
    fill.style.width = `${Math.max(end - start, 0)}%`;
  }

  minRange.style.zIndex = source === minRange ? "3" : "2";
  maxRange.style.zIndex = source === maxRange ? "3" : "2";

  const symbol = slider.dataset.currency || "Rs.";
  if (minLabel) minLabel.textContent = formatPriceLabel(minVal, symbol);
  if (maxLabel) maxLabel.textContent = formatPriceLabel(maxVal, symbol);
}

function applyCollectionPriceValues(form) {
  form.querySelectorAll("[data-price-slider]").forEach((slider) => {
    const minRange = slider.querySelector("[data-price-min-range]");
    const maxRange = slider.querySelector("[data-price-max-range]");
    const minValue = slider.querySelector("[data-price-min-value]");
    const maxValue = slider.querySelector("[data-price-max-value]");
    const ceiling = Number(slider.dataset.max || 0);

    if (minValue && minRange) {
      const minRaw = Number(minRange.value);
      minValue.value = minRaw > 0 ? String(Math.round(minRaw * 100)) : "";
    }

    if (maxValue && maxRange) {
      const maxRaw = Number(maxRange.value);
      maxValue.value = maxRaw < ceiling ? String(Math.round(maxRaw * 100)) : "";
    }
  });
}

function initPriceSliders() {
  document.querySelectorAll("[data-price-slider]").forEach((slider) => {
    const minRange = slider.querySelector("[data-price-min-range]");
    const maxRange = slider.querySelector("[data-price-max-range]");
    if (!minRange || !maxRange) return;

    syncPriceSlider(slider);

    [minRange, maxRange].forEach((input) => {
      input.addEventListener("input", () => syncPriceSlider(slider, input));
      input.addEventListener("change", () => syncPriceSlider(slider, input));
    });
  });
}

function initCollectionFilters() {
  const filterDrawer = document.querySelector("[data-shop-filter-drawer]");
  const filterForms = document.querySelectorAll(
    "[data-collection-toolbar], [data-collection-toolbar-mobile], [data-collection-sidebar]"
  );

  initPriceSliders();

  filterForms.forEach((form) => {
    form.addEventListener("submit", () => applyCollectionPriceValues(form));

    form.querySelectorAll('.shop-facet__check input[type="checkbox"]').forEach((input) => {
      input.addEventListener("change", () => {
        applyCollectionPriceValues(form);
        form.requestSubmit();
      });
    });
  });

  document.querySelectorAll("[data-collection-sort]").forEach((select) => {
    select.addEventListener("change", () => {
      const form = select.closest("form");
      if (form) {
        applyCollectionPriceValues(form);
        form.requestSubmit();
      }
    });
  });

  document.querySelector("[data-open-filters]")?.addEventListener("click", () => {
    if (filterDrawer) filterDrawer.hidden = false;
  });

  document.querySelector("[data-close-filters]")?.addEventListener("click", () => {
    if (filterDrawer) filterDrawer.hidden = true;
  });

  filterDrawer?.addEventListener("click", (e) => {
    if (e.target === filterDrawer) filterDrawer.hidden = true;
  });

  document.querySelectorAll("[data-shop-facet]").forEach((facet) => {
    facet.addEventListener("toggle", () => {
      if (!facet.open) return;
      document.querySelectorAll("[data-shop-facet]").forEach((other) => {
        if (other !== facet) other.open = false;
      });
    });
  });

  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-shop-facet]")) return;
    document.querySelectorAll("[data-shop-facet]").forEach((facet) => {
      facet.open = false;
    });
  });
}

const EMAIL_POPUP_KEY = window.ISL?.emailPopupKey || "isl-email-popup-seen";

function hasSeenEmailPopup() {
  try {
    return window.localStorage.getItem(EMAIL_POPUP_KEY) === "1";
  } catch (_) {
    return false;
  }
}

function markEmailPopupSeen() {
  try {
    window.localStorage.setItem(EMAIL_POPUP_KEY, "1");
  } catch (_) {}
}

function closePopup() {
  markEmailPopupSeen();
  closeDrawer(popup);
}

popup?.addEventListener("click", (e) => {
  if (e.target === popup) closePopup();
});

popup?.querySelectorAll("[data-close-popup]").forEach((btn) => {
  btn.addEventListener("click", closePopup);
});

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && popup && !popup.hidden) closePopup();
});

document.querySelector("[data-popup-form]")?.addEventListener("submit", () => {
  markEmailPopupSeen();
  closePopup();
  showToast("Thanks for subscribing");
});

if (popup && document.body.dataset.page === "index" && !hasSeenEmailPopup()) {
  window.setTimeout(() => {
    if (hasSeenEmailPopup() || !popup || !popup.hidden) return;
    markEmailPopupSeen();
    openDrawer(popup);
  }, 90000);
}

document.querySelector(".newsletter__form")?.addEventListener("submit", () => {
  showToast("You’re on the list");
});

document.querySelector("[data-footer-newsletter]")?.addEventListener("submit", () => {
  showToast("You’re on the list");
});

function enrichQuoteForm(form, fields) {
  const message = form.querySelector("[data-quote-message]");
  const details = message?.value?.trim() || "";
  const parts = [];

  fields.forEach(({ selector, label }) => {
    const value = form.querySelector(selector)?.value?.trim();
    if (value) parts.push(`${label}: ${value}`);
  });

  if (parts.length) parts.push("");
  parts.push(details);

  if (message) message.value = parts.join("\n");
}

document.querySelector("[data-corporate-quote-form]")?.addEventListener("submit", (e) => {
  enrichQuoteForm(e.currentTarget, [
    { selector: "[data-quote-company]", label: "Company" },
    { selector: "[data-quote-sector]", label: "Project type" },
    { selector: "[data-quote-city]", label: "City" },
  ]);
});

document.querySelector("[data-custom-lighting-quote-form]")?.addEventListener("submit", (e) => {
  enrichQuoteForm(e.currentTarget, [
    { selector: "[data-quote-space]", label: "Space type" },
    { selector: "[data-quote-fixture]", label: "Fixture type" },
    { selector: "[data-quote-city]", label: "City" },
  ]);
});

(function initCustomShowcaseLightbox() {
  const lightbox = document.querySelector("[data-custom-lightbox]");
  if (!lightbox) return;

  const imageEl = lightbox.querySelector("[data-custom-lightbox-image]");
  const captionEl = lightbox.querySelector("[data-custom-lightbox-caption]");
  let lastTrigger = null;

  function openLightbox(trigger) {
    const image = trigger.dataset.showcaseImage;
    if (!image || !imageEl) return;

    lastTrigger = trigger;
    imageEl.src = image;
    imageEl.alt = trigger.dataset.showcaseCaption || "Custom lighting project";
    if (captionEl) {
      captionEl.textContent = trigger.dataset.showcaseCaption || "";
    }

    lightbox.hidden = false;
    document.body.classList.add("drawer-open");
    lightbox.querySelector("[data-custom-lightbox-close]")?.focus();
  }

  function closeLightbox() {
    lightbox.hidden = true;
    document.body.classList.remove("drawer-open");
    if (imageEl) {
      imageEl.removeAttribute("src");
      imageEl.alt = "";
    }
    lastTrigger?.focus();
    lastTrigger = null;
  }

  document.querySelectorAll("[data-showcase-lightbox]").forEach((trigger) => {
    trigger.addEventListener("click", () => openLightbox(trigger));
  });

  lightbox.querySelectorAll("[data-custom-lightbox-close]").forEach((el) => {
    el.addEventListener("click", closeLightbox);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !lightbox.hidden) {
      closeLightbox();
    }
  });
})();

document.querySelector("[data-contact-info-form]")?.addEventListener("submit", (e) => {
  const form = e.currentTarget;
  const first = form.querySelector("[data-contact-first-name]")?.value?.trim() || "";
  const last = form.querySelector("[data-contact-last-name]")?.value?.trim() || "";
  const fullName = form.querySelector("[data-contact-full-name]");
  if (fullName) fullName.value = [first, last].filter(Boolean).join(" ");
});

document.querySelector("[data-quote-form]")?.addEventListener("submit", (e) => {
  e.preventDefault();
  showToast("Request sent — we’ll be in touch");
  e.currentTarget.reset();
});

document.querySelector("[data-back-to-top]")?.addEventListener("click", () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
});

document.querySelectorAll("[data-copy-link]").forEach((btn) => {
  btn.addEventListener("click", async () => {
    const url = btn.dataset.copyLink;
    if (!url) return;

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
      } else {
        const input = document.createElement("input");
        input.value = url;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        input.remove();
      }
      showToast("Link copied");
    } catch (error) {
      showToast("Could not copy link");
    }
  });
});

function pad2(n) {
  return String(Math.max(0, n)).padStart(2, "0");
}

function updateCountdown(root) {
  const end = new Date(root.dataset.countdownEnd).getTime();
  const now = Date.now();
  let diff = Math.max(0, end - now);

  const days = Math.floor(diff / 86400000);
  diff %= 86400000;
  const hours = Math.floor(diff / 3600000);
  diff %= 3600000;
  const mins = Math.floor(diff / 60000);
  const secs = Math.floor((diff % 60000) / 1000);

  const daysEl = root.querySelector("[data-days]");
  const hoursEl = root.querySelector("[data-hours]");
  const minsEl = root.querySelector("[data-mins]");
  const secsEl = root.querySelector("[data-secs]");

  if (daysEl) daysEl.textContent = String(days);
  if (hoursEl) hoursEl.textContent = pad2(hours);
  if (minsEl) minsEl.textContent = pad2(mins);
  if (secsEl) secsEl.textContent = pad2(secs);
}

document.querySelectorAll("[data-countdown]").forEach((root) => {
  updateCountdown(root);
  window.setInterval(() => updateCountdown(root), 1000);
});

document.querySelectorAll("[data-legacy-slider]").forEach((slider) => {
  const slides = [...slider.querySelectorAll("[data-legacy-slide]")];
  const dots = [...slider.querySelectorAll("[data-legacy-dot]")];
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const interval = 6500;
  let current = 0;
  let timer;

  function showSlide(index) {
    current = (index + slides.length) % slides.length;

    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === current;
      slide.classList.toggle("is-active", active);
      slide.setAttribute("aria-hidden", String(!active));
    });

    dots.forEach((dot, dotIndex) => {
      const active = dotIndex === current;
      dot.classList.toggle("is-active", active);
      dot.setAttribute("aria-selected", String(active));
    });
  }

  function stopAutoplay() {
    window.clearInterval(timer);
  }

  function startAutoplay() {
    stopAutoplay();
    if (!reducedMotion) {
      timer = window.setInterval(() => showSlide(current + 1), interval);
    }
  }

  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      showSlide(index);
      startAutoplay();
    });
  });

  slider.querySelector("[data-legacy-prev]")?.addEventListener("click", () => {
    showSlide(current - 1);
    startAutoplay();
  });

  slider.querySelector("[data-legacy-next]")?.addEventListener("click", () => {
    showSlide(current + 1);
    startAutoplay();
  });

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      stopAutoplay();
    } else {
      startAutoplay();
    }
  });

  showSlide(0);
  startAutoplay();
});

document.querySelectorAll("[data-showcase-slider]").forEach((slider) => {
  const slides = [...slider.querySelectorAll("[data-showcase-slide]")];
  const currentEl = slider.querySelector("[data-showcase-current]");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  let current = 0;
  let timer;

  function showSlide(index) {
    current = (index + slides.length) % slides.length;

    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === current;
      slide.classList.toggle("is-active", active);
      slide.setAttribute("aria-hidden", String(!active));
    });

    if (currentEl) currentEl.textContent = String(current + 1).padStart(2, "0");
  }

  function startAutoplay() {
    window.clearInterval(timer);
    if (!reducedMotion) {
      timer = window.setInterval(() => showSlide(current + 1), 5500);
    }
  }

  slider.querySelector("[data-showcase-prev]")?.addEventListener("click", () => {
    showSlide(current - 1);
    startAutoplay();
  });

  slider.querySelector("[data-showcase-next]")?.addEventListener("click", () => {
    showSlide(current + 1);
    startAutoplay();
  });

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      window.clearInterval(timer);
    } else {
      startAutoplay();
    }
  });

  showSlide(0);
  startAutoplay();
});

(function initHeaderScroll() {
  const header = document.querySelector(".header");
  if (!header) return;

  const threshold = 12;
  const root = document.documentElement;
  const body = document.body;

  /* Hero/overlay pages only — cart, collection, product keep permanent white header + original logo */
  const overlayHeaderPage = Boolean(
    body &&
      (body.classList.contains("template-index") ||
        body.classList.contains("template-page-about") ||
        body.classList.contains("template-page-corporate-clients") ||
        body.classList.contains("template-page-custom-lighting") ||
        body.classList.contains("template-page-contact") ||
        body.querySelector(".about-page, .clients-hero, .contact-page"))
  );

  function syncHeaderOverlay() {
    const height = Math.ceil(header.getBoundingClientRect().height);
    if (height > 0) {
      root.style.setProperty("--header-overlay", `${height}px`);
    }
  }

  function updateHeaderScroll() {
    const scrolled = overlayHeaderPage && window.scrollY > threshold;
    if (header.classList.contains("is-scrolled") !== scrolled) {
      header.classList.toggle("is-scrolled", scrolled);
    }
  }

  let scrollTicking = false;

  function onScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(() => {
      updateHeaderScroll();
      scrollTicking = false;
    });
  }

  syncHeaderOverlay();
  updateHeaderScroll();
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", syncHeaderOverlay, { passive: true });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncHeaderOverlay).catch(() => {});
  }
})();
